import { RetailerOrigin, UserRoles } from "@core/entities";
import { Modify } from "@core/utils/ts.utils";

export interface InternationalizedAttribute {
  es: string;
  pt: string;
}

export interface CommsMetadata {
  start_date: Date;
  end_date: Date;
  path: string;
  active: boolean;
  id: string;
  dismissable: boolean;
  targetRoles: UserRoles[];
  retailerOrigin?: RetailerOrigin[];
}

export interface CommsInfo {
  image: InternationalizedAttribute | null;
  description: InternationalizedAttribute;
}

export interface CommsItem {
  id: number;
  metaData: CommsMetadata;
  info: CommsInfo[];
  severity: AnnouncementSeverity;
  redirectionModule: InternationalizedAttribute | null;
  title: InternationalizedAttribute;
  subtitle: InternationalizedAttribute | null;
  type: "ANNOUNCEMENT" | "NEW_FEATURE" | "NOTIFICATION";
}

export enum AnnouncementSeverity {
  "INFO" = "INFO",
  "URGENT" = "URGENT",
  "NOVELTY" = "NOVELTY",
}

export type ParsedCommsInfo = Modify<CommsInfo, { image: string | null; description: string | null }>;
export type ParsedCommsItem = Modify<
  CommsItem & { dismissed: boolean; showable: boolean },
  { info: ParsedCommsInfo[]; title: string; subtitle: string | null }
>;
